export default {
  computed: {
    activeJob () {
      return this.$store.state.activeJob
    },
    currentJob () {
      return this.$store.state.currentJob
    },
    activeJobAvailability () {
      let currentJobId = this.$store.state.currentJob
      if (!this.activeJob.isStarted) return true
      if (this.activeJob.id === currentJobId) return true
      return false
    },
    isCurrentJobActive () {
      return function (id) {
        let activeJob = this.$store.state.activeJob
        return (activeJob.id === id && activeJob.isStarted)
      }
    },
    getCurrentJobInfo () {
      let currentJobId = this.currentJob
      if (!currentJobId) return null
      let savedJobs = this.$store.state.driverJobs
      let jobInfo = savedJobs.find(job => {
        return job.id === currentJobId ? job : null
      })
      return jobInfo
    }
  },
  methods: {
    isCurrentJobFinished (jobId) {
      let jobs = this.$store.state.driverJobs
      if (!jobs) return false
      if (jobs.find(job => job.id === jobId && job.isFinished === true)) return true
      return false
    },
    finishedCurrentJob (jobId) {
      this.$store.commit('finishJob', jobId)
    },
    getJobs () {
      if (!this.isLogin) return
      this.$store.dispatch('getJobs')
        .then(response => {
          let resposeHeader = response.data.result.header
          let responseRouteSheet = response.data.result.routeSheet
          if (resposeHeader && resposeHeader.length > 0) {
            let driverName = resposeHeader[0].driverName
            let routeName = resposeHeader[0].routeName
            let testFunctions = resposeHeader[0].testFunctions
            if (driverName) this.$store.commit('updateUserName', driverName)
            if (routeName) this.$store.commit('updateRouteSheetName', routeName)
            if (typeof testFunctions === 'boolean') this.$store.commit('updateTestFunctions', testFunctions)
          }
          if (responseRouteSheet) {
            this.checkAndUpdateSavedJobs(responseRouteSheet)
            if (!this.isActiveJobInJobsList()) {
              this.$store.commit('endJob', null)
              let activeStand = this.$store.state.stands.find(stand => stand.isActive === true)

              if (activeStand) {
                this.$store.commit('endJobActions', activeStand)
              }
            }
          }
        })
        .catch(err => {
          this.showAlert(4, 'Unable to get Jobs list')
          console.log(err)
        })
    },
    checkAndUpdateSavedJobs (routeSheet) {
      if (routeSheet.length === 0) return
      let jobsList = this.$store.state.driverJobs

      // Checking if we do not have saved jobList in vuex or ve have changes in jobs (added, removed)
      if (jobsList.length === 0 || this.checkJobIsUpdated(routeSheet, jobsList)) {
        this.saveJobs(routeSheet)
        this.showAlert(4, 'Jobs list has been updated')
      }
    },
    saveJobs (routeSheet) {
      return this.$store.commit('addDriverJobs', routeSheet)
    },
    deleteJobs () {
      return this.$store.commit('deleteDriverJobs')
    },
    checkJobIsUpdated (receivedJobs, savedJobs) {
      let receivedJobsList = []
      let savedJobsList = []
      for (let key in receivedJobs) {
        receivedJobsList.push(+key)
      }
      for (let key in savedJobs) {
        let jobId = savedJobs[key].id
        savedJobsList.push(jobId)
      }
      // Checking if arrays of jobs Id are equals
      if (this.checkSameArray(receivedJobsList, savedJobsList)) return false
      return true
    },
    checkSameArray (arr1, arr2) {
      if (arr1.length !== arr2.length) return false
      for (let i = 0; i < arr1.length; i++) {
        let correctIndex = arr2.indexOf(arr1[i])
        if (correctIndex === -1) return false
        arr2.splice(correctIndex, 1)
      }
      return true
    },
    isActiveJobInJobsList () {
      let activeJob = this.activeJob
      let activeJobId = activeJob.id
      let activeJobIsFinished = activeJob.isFinished
      if (activeJobIsFinished) return false
      let jobs = this.$store.state.driverJobs
      return jobs.find(job => job.id === activeJobId)
    },
    checkIfJobCreatedFromTablet () {
      let createdJob = this.$store.state.createdCustomJob
      if (createdJob.jobId || createdJob.locationId || createdJob.nameAdress) return true
    }
  }
}
